import { render } from "./Receiver.vue?vue&type=template&id=b236d62c&scoped=true"
import script from "./Receiver.vue?vue&type=script&lang=js"
export * from "./Receiver.vue?vue&type=script&lang=js"

import "./Receiver.vue?vue&type=style&index=0&id=b236d62c&scoped=true&lang=css"

import exportComponent from "E:\\WebstormProjects\\sms-transfer-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b236d62c"]])

export default __exports__